/**
 * Ticket & Request Types Collection.
 *
 * Contains static list of available ticket and request's types, which can be filled with data for
 * different purposes, like filling lists, allowing options selection, etc.
 *
 * deviceInput:
 * - `true`: show device related steps and make them mandatory
 * - `false`: hide device related steps
 * - not set: show device related steps, but not mandatory
 *
 * deviceIdentify:
 * - `true`: the given device has to be identified
 * - `false`: User can still complete step without identification
 *
 * additionalPartyInput:
 * - `false`: always hide additional party related steps
 *
 * softwareInput:
 * - `true`: Display fields {@ deviceFirmwareVersion}, `PCSoftwareProgram` and
 * `PCSoftwareVersion` in issue step. Fields are still optional.
 * - `false`: Don't display them.
 *
 * fieldServiceInput:
 * - `true`: Display fields `deviceMalfunction`, `serviceCallDesiredDateStart` and
 * `serviceCallDesiredDateEnd` in issue step. Fields are still optional.
 * - `false`: Don't display them.
 */
export default [
  {
    key: 'device_breakdown',
    value: 'Device breakdown',
    icon: 'alert-triangle',
    deviceInput: true,
    deviceIdentify: true,
  },
  {
    key: 'technical_issue',
    value: 'Technical issue',
    icon: 'alert-square',
    deviceInput: true,
    softwareInput: true,
  },
  {
    key: 'software_support',
    value: 'Software support',
    icon: 'terminal',
    softwareInput: true,
  },
  {
    key: 'clarification_spare_parts',
    value: 'Spare part',
    icon: 'part',
  },
  {
    key: 'general_service_request',
    value: 'General',
    icon: 'help',
  },
  {
    key: 'require_service',
    value: 'Require service',
    icon: 'tool',
    hidden: true,
  },
  {
    key: 'field_service',
    value: 'Field service',
    icon: 'tool',
    fieldServiceInput: true,
  },
  {
    key: 'remote_support',
    value: 'Remote support',
    icon: 'settings-remote',
    hidden: true,
  },
  {
    key: 'digital_platform',
    value: 'Digital platform',
    icon: 'webhook',
    hidden: true,
  },
  {
    key: 'order_spare_parts',
    value: 'Order spare parts',
    icon: 'spare-part-quotation',
    hidden: true,
  },
  {
    key: 'order_consumables',
    value: 'Order consumables',
    icon: 'package',
    hidden: true,
  },
  {
    key: 'suggestion',
    value: 'Suggestion',
    icon: 'message-text',
    deviceInput: false,
    hidden: true,
  },
  {
    key: 'feedback_commendation',
    value: 'Feedback/Commendation',
    icon: 'message-text',
    deviceInput: false,
    hidden: true,
  },
  {
    key: 'complaint',
    value: 'Complaint',
    icon: 'face-frown',
    deviceInput: false,
    hidden: true,
  },
  {
    key: 'other',
    value: 'Other',
    icon: 'dots-horizontal',
    deviceInput: false,
  },
]
